import { useViewer } from '@/entities/viewer';
import { InterfaceSettings } from '@/features/interface-settings';
import { SettingsShell } from '@/features/settings-shell';
import { LoadingState } from '@/shared/ui';

export function InterfaceSettingsPage() {
  const viewer = useViewer();
  if (viewer.status !== 'authenticated') return <LoadingState />;
  return (
    <SettingsShell>
      <InterfaceSettings user={viewer.user} />
    </SettingsShell>
  );
}
